import { useState } from 'react';
import { Button, Drawer, List, Image, Modal } from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useCarMentenanceContext } from './carMaintenanceProvider';

import CarTypesEditModal from './carTypesEditModal';

export default function CarTypes() {
  const [open, setOpen] = useState(false);
  const [editType, setEditType] = useState();
  const { carTypes, deleteCarType } = useCarMentenanceContext();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleClodeEditModal = () => {
    setEditType(undefined);
  };

  return (
    <>
      <Button variant="outlined" onClick={showDrawer}>
        車型清單
      </Button>
      <Drawer
        title="車型清單"
        placement="left"
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={open}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <List
            itemLayout="horizontal"
            dataSource={carTypes}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<Image src={item.img_path} width={120} />}
                  title={item.name}
                  description={item.description}
                />
                <Button
                  key="edit"
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={() => {
                    console.log('編輯', item.name);
                    setEditType(item);
                  }}
                />
                <Button
                  type="primary"
                  danger
                  icon={<DeleteOutlined />}
                  className="button--delete"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    Modal.confirm({
                      title: '刪除車型',
                      content: (
                        <p>
                          你確定要刪除 {item.name} 這個車型嗎？
                          <br />
                          所屬該車型的車款會被保留但不在展示間顯示。
                        </p>
                      ),
                      okText: '確定',
                      cancelText: '取消',
                      onOk: async () => await deleteCarType(item.id),
                    });
                  }}
                />
              </List.Item>
            )}
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="button button--register"
            style={{ marginTop: '10px' }}
            onClick={() => {
              setEditType(null);
            }}>
            新增
          </Button>
        </div>
        <CarTypesEditModal typeData={editType} onClose={handleClodeEditModal} />
      </Drawer>
    </>
  );
}
